import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sellerRankInitialState } from 'v3/data/store/Rank/RankSeller/state';
import {
  IRankSellerList,
  ISellerRankingReportState,
  ISellerRankState,
  SellerRankingReportStatus,
} from 'v3/data/store/Rank/RankSeller/types';

export const rankSellerSlice = createSlice({
  name: 'rankSeller',
  initialState: sellerRankInitialState,
  reducers: {
    setRankList: (state, action: PayloadAction<IRankSellerList>) => {
      state.list = action.payload;
      return state;
    },
    setFilterRowsPerPage: (state, action: PayloadAction<number>) => {
      state.filter.rowsPerPage = action.payload;
      return state;
    },
    setFilterCurrentPage: (state, action: PayloadAction<number>) => {
      state.filter.page = action.payload;
      return state;
    },
    setStartDate(state, action: PayloadAction<string>) {
      state.filter.startDate = action.payload;
    },
    setFinalDate(state, action: PayloadAction<string>) {
      state.filter.finalDate = action.payload;
    },
    updateFilter(state, action: PayloadAction<Partial<ISellerRankState['filter']>>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    resetFilter(state) {
      state.filter = sellerRankInitialState.filter;
    },
    setReportJobId(state, action: PayloadAction<string | null>) {
      state.report.jobId = action.payload;
    },
    setReportStatus(state, action: PayloadAction<SellerRankingReportStatus>) {
      state.report.status = action.payload;
    },
    setReportUrl(state, action: PayloadAction<string | null>) {
      state.report.url = action.payload;
    },
    setReportState(state, action: PayloadAction<ISellerRankingReportState>) {
      state.report = action.payload;
    },
    resetReportState(state) {
      state.report = sellerRankInitialState.report;
    },
  },
});
